import React from "react";
import "./TypingIndicator.css";

const TypingIndicator = () => {
  return (
    <div className="typingIndicatorContainer">
      <div className="typingIndicatorBubble">
        <div className="typingIndicatorBubbleDot"></div>
        <div className="typingIndicatorBubbleDot"></div>
        <div className="typingIndicatorBubbleDot"></div>
      </div>
    </div>
  );
};

export default TypingIndicator;
